import AuthTypes from './AuthTypes';

export const setLoginSuccess = (payload) => ({
  payload,
  type: AuthTypes.LOGIN_IN_SUCCESS,
});

export const getUserMenuInProgress = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_MENU_PROGRESS,
});

export const getUserMenuInSuccess = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_MENU_SUCCESS,
});

export const getUserMenuInError = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_MENU_ERROR,
});

export const getUserMenuItemsInProgress = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_MENU_ITEMS_PROGRESS,
});

export const getUserMenuItemsInSuccess = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_MENU_ITEMS_SUCCESS,
});

export const getUserMenuItemsInError = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_MENU_ITEMS_ERROR,
});

export const setSelectedCompany = (payload) => ({
  payload,
  type: AuthTypes.SET_SELECTED_COMPANY,
});

export const getUserProfileInProgress = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_PROFILE_PROGRESS,
});

export const getUserProfileInSuccess = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_PROFILE_SUCCESS,
});

export const getUserProfileInError = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_PROFILE_ERROR,
});

export const getUserPreferenceInProgress = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_PREFERENCE_PROGRESS,
});
export const getUserPreferenceInSuccess = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_PREFERENCE_SUCCESS,
});
export const getUserPreferenceInError = (payload) => ({
  payload,
  type: AuthTypes.GET_USER_PREFERENCE_ERROR,
});

export const changeCompanyInProgress = (payload) => ({
  payload,
  type: AuthTypes.CHANGE_COMPANY_IN_PROGRESS,
});

export const changeCompanyInSuccess = (payload) => ({
  payload,
  type: AuthTypes.CHANGE_COMPANY_IN_SUCCESS,
});

export const changeCompanyInFail = (payload) => ({
  payload,
  type: AuthTypes.CHANGE_COMPANY_IN_FAIL,
});

export const approveRejectShipmentInProgress = (payload) => ({
  payload,
  type: AuthTypes.APPROVE_REJECT_SHIPMENT_IN_PROGRESS,
});
export const approveRejectShipmentInSuccess = (payload) => ({
  payload,
  type: AuthTypes.APPROVE_REJECT_SHIPMENT_IN_SUCCESS,
});
export const approveRejectShipmentInFail = (payload) => ({
  payload,
  type: AuthTypes.APPROVE_REJECT_SHIPMENT_IN_FAIL,
});
